export enum NotificationType {
    Light,
    Dark,
    Primary,
    Secondary,
    Success,
    Danger,
    Warning,
    Info
}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification-type.enum.ts